'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Table = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tborder-radius: 4px;\n\tbox-shadow: ', ';\n\tbackground-color: #fff;\n\twidth: 100%;\n    border: none;\n\tborder-spacing: 0;\n\tborder-collapse: collapse;\n\tword-wrap: break-word;\n    word-break: break-all;\n\ttable-layout: fixed;\n\tposition: relative;\n'], ['\n\tborder-radius: 4px;\n\tbox-shadow: ', ';\n\tbackground-color: #fff;\n\twidth: 100%;\n    border: none;\n\tborder-spacing: 0;\n\tborder-collapse: collapse;\n\tword-wrap: break-word;\n    word-break: break-all;\n\ttable-layout: fixed;\n\tposition: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t> tr {\n\t\tborder-bottom: 1px solid #D8E5EE;\n\t\tbackground-color: #fff;\n\t\tword-break: keep-all;\n\n\t\t&:hover {\n\t\t\tbackground-color: #fff;\n\t\t}\n\t}\n'], ['\n\t> tr {\n\t\tborder-bottom: 1px solid #D8E5EE;\n\t\tbackground-color: #fff;\n\t\tword-break: keep-all;\n\n\t\t&:hover {\n\t\t\tbackground-color: #fff;\n\t\t}\n\t}\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tposition: absolute;\n\tz-index: 5;\n\ttop: 30px;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t> div > .table-spinner-wrapper > .table-spinner {\n\t\tpadding: 10px;\n\t}\n'], ['\n\tposition: absolute;\n\tz-index: 5;\n\ttop: 30px;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t> div > .table-spinner-wrapper > .table-spinner {\n\t\tpadding: 10px;\n\t}\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n\tfont-weight: normal;\n\tdisplay: flex;\n\talign-items: center;\n\n\t', ';\n\n\t> .label {\n\t\tcolor: #8DABC4;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 1px;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tword-break: unset;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\n\t\t&:last-of-type {\n\t\t\tborder-radius: 0 3px 0 0;\n\t\t}\n\t}\n\n\t> .sort-icon {\n\t\tfill: #8DABC4;\n\t\tmargin-left: 8px;\n\t\theight: 12px;\n\t\twidth: 12px;\n\t\tmin-width: 12px;\n\t}\n'], ['\n\tfont-weight: normal;\n\tdisplay: flex;\n\talign-items: center;\n\n\t', ';\n\n\t> .label {\n\t\tcolor: #8DABC4;\n\t\ttext-transform: uppercase;\n\t\tletter-spacing: 1px;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tword-break: unset;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\n\t\t&:last-of-type {\n\t\t\tborder-radius: 0 3px 0 0;\n\t\t}\n\t}\n\n\t> .sort-icon {\n\t\tfill: #8DABC4;\n\t\tmargin-left: 8px;\n\t\theight: 12px;\n\t\twidth: 12px;\n\t\tmin-width: 12px;\n\t}\n']),
    _templateObject5 = _taggedTemplateLiteral(['cursor: pointer'], ['cursor: pointer']),
    _templateObject6 = _taggedTemplateLiteral([''], ['']),
    _templateObject7 = _taggedTemplateLiteral(['\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ', ';\n\t\t\t}\n\t\t'], ['\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ', ';\n\t\t\t}\n\t\t']),
    _templateObject8 = _taggedTemplateLiteral(['\n\t\t\theight: 60px;\n\t\t\tdisplay: flex;\n\t\t'], ['\n\t\t\theight: 60px;\n\t\t\tdisplay: flex;\n\t\t']),
    _templateObject9 = _taggedTemplateLiteral(['\n\theight: 45px;\n\tborder-bottom: 1px solid #E5EEF5;\n\tbackground-color: #fff;\n\n\t', '\n\n\t> th,\n\t> td {\n\t\tfont-size: 14px;\n\t\tcolor: #3F536E;\n\t\tpadding: 0 10px;\n\n\t\t&:first-of-type {\n\t\t\tpadding-left: 20px;\n\t\t}\n\n\t\t> p {\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #3F536E;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tword-break: unset;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t}\n\t}\n'], ['\n\theight: 45px;\n\tborder-bottom: 1px solid #E5EEF5;\n\tbackground-color: #fff;\n\n\t', '\n\n\t> th,\n\t> td {\n\t\tfont-size: 14px;\n\t\tcolor: #3F536E;\n\t\tpadding: 0 10px;\n\n\t\t&:first-of-type {\n\t\t\tpadding-left: 20px;\n\t\t}\n\n\t\t> p {\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #3F536E;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tword-break: unset;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t}\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SortDown = require('./icons/SortDown');

var _SortDown2 = _interopRequireDefault(_SortDown);

var _SortUp = require('./icons/SortUp');

var _SortUp2 = _interopRequireDefault(_SortUp);

var _SortNeutral = require('./icons/SortNeutral');

var _SortNeutral2 = _interopRequireDefault(_SortNeutral);

var _Spinner = require('./Spinner');

var _Paper = require('./Paper');

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTable = _styledComponents2.default.table(_templateObject, _globals2.default.styles.boxShadow);

var StyledTableHeader = _styledComponents2.default.thead(_templateObject2);

var StyledTableSpinner = _styledComponents2.default.div(_templateObject3);

var StyledTableHeading = _styledComponents2.default.div(_templateObject4, function (props) {
	return props.onClick ? (0, _styledComponents.css)(_templateObject5) : '';
});

var StyledTableBody = _styledComponents2.default.tbody(_templateObject6);

var rowMixin = function rowMixin(_ref) {
	var onClick = _ref.onClick,
	    loading = _ref.loading;

	if (onClick) {
		return (0, _styledComponents.css)(_templateObject7, _globals2.default.colors.cloud);
	}

	if (loading) {
		return (0, _styledComponents.css)(_templateObject8);
	}
};

var StyledTableRow = _styledComponents2.default.tr(_templateObject9, function (props) {
	return rowMixin(props);
});

var Table = function (_Component) {
	_inherits(Table, _Component);

	function Table(props) {
		_classCallCheck(this, Table);

		var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

		_this.state = {
			sorted: {
				type: '',
				value: 0
			}
		};
		return _this;
	}

	_createClass(Table, [{
		key: 'changeSorting',
		value: function changeSorting(type) {
			var sorted = this.state.sorted;


			if (sorted.type == type) {
				var newValue = 0;

				switch (sorted.value) {
					case 1:
						newValue = -1;
						break;
					case -1:
						newValue = 1;
						break;
					case 0:
						newValue = 1;
						break;
				}

				this.setState({
					sorted: _extends({}, sorted, {
						value: newValue
					})
				});
			} else {
				this.setState({
					sorted: {
						type: type,
						value: 1
					}
				});
			}
		}
	}, {
		key: 'getCellValue',
		value: function getCellValue(cell) {
			if (typeof cell == 'string' || !cell) {
				return cell;
			} else if ((typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) == 'object' && cell.value && typeof cell.value == 'string') {
				return cell.value;
			}

			return null;
		}
	}, {
		key: 'getCellRender',
		value: function getCellRender(cell) {
			if (typeof cell == 'string' || !cell) {
				return cell;
			} else if ((typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) == 'object' && cell.value && typeof cell.render == 'function') {
				return cell.render();
			}

			return null;
		}
	}, {
		key: 'getSortedRows',
		value: function getSortedRows(rows) {
			var _this2 = this;

			var sorted = this.state.sorted;
			var columns = this.props.columns;


			if (!sorted.value) return rows;

			var index = columns.indexOf(columns.find(function (column) {
				return column.value == sorted.type;
			}));
			var sortedRows = rows.slice(0);

			var formatValue = function formatValue(cell) {
				var value = _this2.getCellValue(cell);

				if (columns[index].formatter && typeof columns[index].formatter == 'function') {
					return columns[index].formatter(value);
				} else {
					return value;
				}
			};

			var sortRows = function sortRows(a, b) {
				var aValue = formatValue(a.cells[index]);
				var bValue = formatValue(b.cells[index]);

				var comparison = 0;
				// ascending
				if (sorted.value == 1) {
					if (aValue < bValue) {
						comparison = -1;
					} else if (aValue > bValue) {
						comparison = 1;
					}
					// descending
				} else if (sorted.value == -1) {
					if (aValue > bValue) {
						comparison = -1;
					} else if (aValue < bValue) {
						comparison = 1;
					}
				}

				return comparison;
			};

			sortedRows.sort(sortRows);

			return sortedRows;
		}
	}, {
		key: 'getSearchedRows',
		value: function getSearchedRows(rows) {
			var _this3 = this;

			var columns = this.props.columns;


			var hasFiltering = columns.find(function (column) {
				return column.filter || column.search;
			});
			if (!hasFiltering) return rows;

			return rows.filter(function (row) {
				var cells = row.cells;


				var show = false;
				for (var i = 0; i < cells.length; i++) {
					var _columns$i = columns[i],
					    search = _columns$i.search,
					    filter = _columns$i.filter;


					var value = _this3.getCellValue(cells[i]);
					var inSearch = false;

					if (search && typeof search == 'function') {
						inSearch = search(value);
					}

					if (value) {
						if (filter && typeof filter == 'function') {
							var inFilter = filter(value);

							if (inFilter && inSearch) {
								show = true;
							} else if (!inFilter) {
								show = false;
							}
						} else {
							if (inSearch) {
								show = true;
							}
						}
					}
				}

				return show;
			});
		}
	}, {
		key: 'getRows',
		value: function getRows() {
			var rows = this.props.rows;


			var sortedRows = this.getSortedRows(rows);
			return this.getSearchedRows(sortedRows);
		}
	}, {
		key: 'renderHeadings',
		value: function renderHeadings() {
			var _this4 = this;

			var sorted = this.state.sorted;
			var columns = this.props.columns;


			return columns.map(function (column, index) {
				if (typeof column.formatter == 'function') {
					var icon = null;

					if (column.value == sorted.type) {
						switch (sorted.value) {
							case -1:
								icon = _react2.default.createElement(_SortDown2.default, { className: 'sort-icon' });
								break;
							case 1:
								icon = _react2.default.createElement(_SortUp2.default, { className: 'sort-icon' });
								break;
							case 0:
								icon = _react2.default.createElement(_SortNeutral2.default, { className: 'sort-icon' });
								break;
						}
					} else {
						icon = _react2.default.createElement(_SortNeutral2.default, { className: 'sort-icon' });
					}

					return _react2.default.createElement(
						'th',
						{ key: index },
						_react2.default.createElement(
							StyledTableHeading,
							{
								onClick: function onClick() {
									return _this4.changeSorting(column.value);
								} },
							_react2.default.createElement(
								'p',
								{ className: 'label' },
								column.value
							),
							icon
						)
					);
				} else {
					return _react2.default.createElement(
						'th',
						{ key: index },
						_react2.default.createElement(
							StyledTableHeading,
							null,
							_react2.default.createElement(
								'p',
								{ className: 'label' },
								column.value
							)
						)
					);
				}
			});
		}
	}, {
		key: 'renderLoadingRow',
		value: function renderLoadingRow() {
			return _react2.default.createElement(
				StyledTableRow,
				{ loading: true },
				_react2.default.createElement(
					'td',
					{ style: { width: 60, height: 60 } },
					_react2.default.createElement(_Spinner.Spinner, { success: true, tint: true })
				)
			);
		}
	}, {
		key: 'renderNullRow',
		value: function renderNullRow() {
			var columns = this.props.columns;


			var cells = columns.map(function (column, index) {
				return _react2.default.createElement(
					'td',
					{ key: index },
					'\u2014'
				);
			});

			return _react2.default.createElement(
				StyledTableRow,
				null,
				cells
			);
		}
	}, {
		key: 'renderRows',
		value: function renderRows() {
			var _this5 = this;

			var rows = this.getRows();
			if (rows.length == 0) return this.renderNullRow();

			if (rows.length > 0) {
				return rows.map(function (row, index) {
					var cells = row.cells.map(function (cell, index) {
						var value = _this5.getCellRender(cell);

						if (value) {
							return _react2.default.createElement(
								'td',
								{ key: index },
								_react2.default.createElement(
									'p',
									{ title: value },
									value
								)
							);
						} else {
							return _react2.default.createElement(
								'td',
								{ key: index },
								'\u2014'
							);
						}
					});

					if (row.onClick && typeof row.onClick == 'function') {
						return _react2.default.createElement(
							StyledTableRow,
							{
								key: index,
								onClick: row.onClick },
							cells
						);
					} else {
						return _react2.default.createElement(
							StyledTableRow,
							{ key: index },
							cells
						);
					}
				});
			}

			return null;
		}
	}, {
		key: 'renderSpinner',
		value: function renderSpinner() {
			var loading = this.props.loading;


			if (loading) {
				return _react2.default.createElement(
					StyledTableSpinner,
					null,
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_Paper.Paper,
							{ circle: true, className: 'table-spinner-wrapper' },
							_react2.default.createElement(
								'div',
								{ className: 'table-spinner' },
								_react2.default.createElement(_Spinner.Spinner, { primary: true, tint: true, sm: true })
							)
						)
					)
				);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				StyledTable,
				null,
				_react2.default.createElement(
					StyledTableHeader,
					null,
					_react2.default.createElement(
						StyledTableRow,
						null,
						this.renderHeadings()
					)
				),
				_react2.default.createElement(
					StyledTableBody,
					null,
					this.renderSpinner(),
					this.renderRows()
				)
			);
		}
	}]);

	return Table;
}(_react.Component);

Table.propTypes = {
	loading: _propTypes2.default.bool,
	columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _propTypes2.default.string,
		formatter: _propTypes2.default.func,
		filter: _propTypes2.default.func,
		search: _propTypes2.default.func
	})),
	rows: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		onClick: _propTypes2.default.func,
		cells: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
			value: _propTypes2.default.string,
			render: _propTypes2.default.func
		})]))
	}))
};
Table.defaultProps = {
	columns: [],
	rows: []
};
exports.Table = Table;